import { updateFilesEntries } from './updateFilesThunk';
export default updateFilesEntries;
